import { fontSize } from "config/styles/fonts";

const styles = {
  priceContentWrap: (orderId: boolean) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: orderId ? 0 : "10px",
  }),
  priceWrap: {
    display: "flex",
    gap: "2px",
    alignItems: "flex-end",
    color: "text.primary",
  },
  price: {
    fontSize: fontSize.xxxl,
    fontWeight: 700,
    lineHeight: 1,
  },
  currency: {
    fontSize: fontSize.xl,
    fontWeight: 500,
    lineHeight: 1.2,
  },
  addCost: (isAddCostShown: boolean) => ({
    display: isAddCostShown ? "block" : "none",
    width: "26px",
    height: "50px",
    "&.MuiFormControl-root.MuiTextField-root": {
      justifyContent: "center",
      pl: "16px",
    },
    "&.MuiFormControl-root.MuiTextField-root:hover .MuiOutlinedInput-notchedOutline":
      {
        border: "none",
      },
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "& .MuiInputBase-root fieldset": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      height: "40px",
      p: 0,
    },
    "& .MuiInputBase-input": {
      textAlign: "center",
      height: 0,
    },
    "& .MuiButtonBase-root.MuiIconButton-root": {
      display: "inline-flex !important",
    },
    "& .MuiInputAdornment-root": {
      ml: 0,
      mr: 0,
      width: "20px",
      height: "20px",
      "& .MuiButtonBase-root": {
        width: "20px",
        height: "20px",
        border: "none",
      },
    },
    "& .MuiButtonBase-root": {
      p: 0,
      "&:hover": {
        backgroundColor: "unset",
        border: "none",
      },
    },
  }),
};

export default styles;
